<template>
  <div>
    <div class="pie-container">
      <div class="pie-row">
        <div class="pie-col" v-for="(pieData, index) in pieDataList" :key="index">
          <el-card class="el-card">
            <div class="chart-container1">
              <div class="chart" :ref="'chart' + index"></div>
            </div>
            <div class="chart-title1">{{ pieData.title }}</div>
          </el-card>
        </div>
      </div>
    </div>

    <div class="line-chart-container">
      <div class="control-panel">
        <!-- 日期选择器 -->
        <el-date-picker
          v-model="selectedJapaneseZhouYueLivingColum"
          type="date"
          :picker-options="pickerDataZhouYueLivingRoate"
          :editable="false"
          @input="handleDateInputData"
        ></el-date-picker>

        <!-- 时间范围按钮 -->
      </div>

      <!-- 折线图容器 -->
      <div class="line-chart" :ref="'JapaneseZhouYueLivingRoate'">

      </div>
      <div class="chart-titleTotol">日活周活月活分布</div>


    </div>

    <div class="line-chart-container">
      <div class="control-panel">
        <!-- 日期选择器 -->
        <el-date-picker
          v-model="selectedDateRangeLine"
          type="daterange"
          :picker-options="pickerOptionsLine"
          :editable="false"
          @input="handleDateInputLine"
        ></el-date-picker>

        <!-- 时间范围按钮 -->
        <div class="range-buttons">
          <el-button @click="setDateRangeLine('近一周')">近一周</el-button>
          <el-button @click="setDateRangeLine('近一个月')">近一个月</el-button>
          <el-button @click="setDateRangeLine('近三个月')">近三个月</el-button>
        </div>
      </div>

      <!-- 折线图容器 -->
      <div class="PeopleCss">
        总人数:
        <span>{{message}}</span>
        <span>人</span>
      </div>

      <div class="line-chart" :ref="'lineChart'">
      </div>
      <div class="chart-titleTotol">活跃人数，登录人数，总人数，完成推送人数折线图</div>


    </div>
    <div class="line-chart-container">
      <div class="control-panel">
        <!-- 日期选择器 -->

        <!-- 时间范围按钮 -->
      </div>

      <!-- 折线图容器 -->
      <div class="line-chart" :ref="'RetentionRateChat'">

      </div>
      <div class="chart-titleTotol">用户留存率统计</div>


    </div>
    <div class="line-chart-container">
      <div class="control-panel">
        <!-- 日期选择器 -->
        <el-date-picker
          v-model="selectedDateRangeLineAndColumn"
          type="daterange"
          :picker-options="pickerOptionsLineAndColumn"
          :editable="false"
          @input="handleDateInputLineAndColum"
        ></el-date-picker>
        <div class="range-buttons">
          <el-button @click="setDateRangeLineAndColum('近一周')">近一周</el-button>
          <el-button @click="setDateRangeLineAndColum('近一个月')">近一个月</el-button>
          <el-button @click="setDateRangeLineAndColum('近三个月')">近三个月</el-button>
        </div>
        <!-- 时间范围按钮 -->
      </div>


      <!-- 折线图容器 -->
      <div class="line-chart" :ref="'lineChartAndColumn'">

      </div>
      <div class="chart-titleTotol">点击次数，平均使用时长，总使用时长折线柱状图</div>


    </div>

    <div class="line-chart-container">
      <div class="control-panel">
        <!-- 日期选择器 -->
        <el-date-picker
          v-model="selectedDateRangeLineEvery"
          type="date"
          :picker-options="pickerOptionsLineEvery"
          :editable="false"
          @input="handleDateInputLineEvery"
        ></el-date-picker>

        <!-- 时间范围按钮 -->
      </div>

      <!-- 折线图容器 -->
      <div class="line-chart" :ref="'lineChartEvery'">

      </div>
      <div class="chart-titleTotol">各模块使用时长和点击次数</div>


    </div>

    <div class="line-chart-container">
      <div class="control-panel">
        <!-- 日期选择器 -->

        <!-- 时间范围按钮 -->
      </div>

      <!-- 折线图容器 -->
      <div class="line-chart" :ref="'ColumChartRedEnvelope'">

      </div>
      <div class="chart-titleTotol">用户获取红包统计</div>


    </div>

    <div class="map-container">
      <div ref="mapChart" class="map-chart"></div>
      <div class="pie-chart111">
        <div class="chartMap" ref="pieChart"></div>

      </div>
      <div class="chart-title">各省市区人数分布</div>
    </div>


    <div class="bar-container">
      <el-card class="el-card">
        <div class="chart-container">
          <div class="dropdown-container">
            <div class="control-panel">
              <!-- 日期选择器 -->
              <el-date-picker
                v-model="selectedDaoPeopleColumn"
                type="daterange"
                :picker-options="pickerDaoPeopleColumn"
                :editable="false"
                @input="handleDateDaoPeopleColum"
              ></el-date-picker>
              <div class="range-buttons">
                <!-- <div>{{selectedDaoPeopleColumn}}</div> -->
                <el-button @click="setDateDaoPeopleColum('近一周')">近一周</el-button>
                <el-button @click="setDateDaoPeopleColum('近一个月')">近一个月</el-button>
                <el-button @click="setDateDaoPeopleColum('近三个月')">近三个月</el-button>
              </div>
              <!-- 时间范围按钮 -->
<!--              <el-button class="button-Dao" type="primary" @click="updateBarChart">确定</el-button>-->
            </div>
            <el-button class="ExportRecord" type="success"  size="small"  @click="exportDaoData">导出记录</el-button>
          </div>
        </div>
      </el-card>
      <div class="chart-title1">导出限定时间日期内的人数</div>
    </div>


    <div class="bar-container">
      <el-card class="el-card">
        <div class="chart-container">
          <div class="dropdown-container">
            <el-cascader
              v-model="selectedArea"
              :options="districts"
              placeholder="请选择省市区"
              class="dropdown"
              :props="{
   value: 'label',
  label: 'label',
  }"
            ></el-cascader>
            <el-button type="primary" @click="updateBarChart">确定</el-button>

            <el-button class="ExportRecord" type="success"  size="small"  @click="exportData">导出记录</el-button>

          </div>
          <div class="PeopleCssProve">
            总人数:
            <span>{{messageProviced}}</span>
            <span>人</span>
          </div>
          <div class="chart222" :ref="'barChart'">
          </div>
        </div>
        <div class="chart-title1">各省市区街道下用户数量</div>
      </el-card>
    </div>



  </div>


</template>

<script>
import * as echarts from 'echarts';
import chinaMap from "@/assets/json/china.json";
import axios from "axios";
import fa from "element-ui/src/locale/lang/fa";
import Fa from "element-ui/src/locale/lang/fa";

export default {
  data() {

    return {

      pieDataList: [
        {
          title: '年龄分布',
          data: [

          ]
        },
        {
            title: '用户设备分布',
          data: [

          ]
        },
        // {
        //   title: '日活，周活，月活人数',
        //   data: [
        //
        //   ]
        // },
        // {
        //   title: '空',
        //   data: [
        //
        //   ]
        // },
        // {
        //   title: '当天活跃人数和当天登录',
        //   data: [
        //
        //   ]
        // },
        // {
        //   title: '当天注册和总注册',
        //   data: [
        //
        //   ]
        // }
      ],  //饼状图的标题和数据
      districts: [
        {

          label: '省份1',
          children: [
            {

              label: '市1',
              children: [
                {

                  label: '区1',
                  areas: [
                    {name: '街道1', value: 100},
                    {name: '街道2', value: 200},
                    {name: '街道3', value: 150}
                  ]
                },
                // 其他区的数据...
              ]
            },
            {

              label: '市2',
              children: [
                {

                  label: '区3',
                  areas: [
                    {name: '街道1', value: 2},
                    {name: '街道2', value: 200},
                    {name: '街道3', value: 150}
                  ]
                },
                {

                  label: '区4',
                  areas: [
                    {name: '街道5', value: 2},
                    {name: '街道5', value: 80},
                    {name: '街道3', value: 150}
                  ]
                },
                // 其他区的数据...
              ]
            },
            // 其他市的数据...
          ]
        },
        {

          label: '省份2',
          children: [
            {

              label: '市2',
              children: [
                {

                  label: '区2',
                  areas: [
                    {name: '街道2', value: 100},
                    {name: '街道2', value: 200},
                    {name: '街道2', value: 200},
                    {name: '街道2', value: 200},

                    {name: '街道2', value: 150}
                  ]
                },
                // 其他区的数据...
              ]
            },
            // 其他市的数据...
          ]
        },
      ], // 区的选项数据
      downExcel:'',  //导出记录
      selectedArea: [],// 默认选中的区
      showLabel:true,
      pieChart:null, //饼状图
      mapChart: null, //地图
      showPieChart: false,
      provinceData: {
        北京市: [
          { name: '东城区', value: 30 },
          { name: '西城区', value: 20 },
          { name: '朝阳区', value: 40 },
          // Add more city data as needed
        ],
        上海市: [
          { name: '黄浦区', value: 50 },
          { name: '徐汇区', value: 60 },
          { name: '静安区', value: 70 },
          // Add more city data as needed
        ],
        广东省: [
          { name: '广州市', value: 70 },
          { name: '深圳市', value: 80 },
          { name: '珠海市', value: 90 },
          // Add more city data as needed
        ],
        // Add more province-city data as needed
      }, //最下面的省份的柱状图
      currentProvince: '',
      selectedDates: [ new Date(),new Date(), new Date(), new Date()], // 默认为今天，根据需要初始化数组长度
      minDate: new Date('2023-03-01'),
      maxDate: new Date(),
      arrowControl: true, // 控制箭头显示与隐藏
      NumberLoginDay:0,
      TotalRegistration:0,
      messageProviced:20,
      //活跃人数折线图的数据
      selectedDateRangeLine: [   ], // 选定的时间范围
      lineChart: null,
      dataLine: [
        // ...更多数据
      ],
      pickerOptionsLine: {
        disabledDate: (time) => {
          const date = new Date(time);
          return date < new Date('2023-03-01') || date > new Date();
        },
      },
      //总登录时间的数据
      selectedDateRangeLineAndColumn: [   ], // 选定的时间范围
      lineChartAndColumn: null,
      dataLineAndColumn: [
        // ...更多数据
      ],
      pickerOptionsLineAndColumn: {
        disabledDate: (time) => {
          const date = new Date(time);
          return date < new Date('2023-03-01') || date > new Date();
        },
      },

      selectedJapaneseZhouYueLivingColum:null,
      JapaneseZhouYueLivingRoate:null,
      DataZhouYueLivingRoate:[],
      pickerDataZhouYueLivingRoate: {
        disabledDate: (time) => {
          const date = new Date(time);
          return date < new Date('2023-03-01') || date > new Date();
        },
      },
      // 各模块的数据
      selectedDateRangeLineEvery: new Date(), // 默认为今天
      lineChartEvery: null,
      dataLineEvery: [
        // ...更多数据
      ],
      pickerOptionsLineEvery: {
        disabledDate: (time) => {
          const date = new Date(time);
          return date < new Date('2023-03-01') || date > new Date();
        },
      },
      // 红包分布的数据
      ColomChartRedEnvelope: null,
      ColomChartRedEnvelopeArr: [
        // ...更多数据
      ],
      // 用户1-180天留存率
      RetentionRateChat:null,
      RetentionRateChatArray:[],

      //导出限定日期的人
      selectedDaoPeopleColumn:[],
      pickerDaoPeopleColumn: {
        disabledDate: (time) => {
          const date = new Date(time);
          return date < new Date('2023-03-01') || date > new Date();
        },
      },
    };
  },




  mounted() {

//初始化时间和柱状图
    this.getInfo();
    const currentDate = new Date();
    const oneWeekAgo = new Date();
    const oneWeekAgo2 = new Date();
    oneWeekAgo.setDate(currentDate.getDate() - 7);
    oneWeekAgo2.setDate(currentDate.getDate() - 1);
    const startDate = this.formatDate(oneWeekAgo);
    const endDate = this.formatDate(currentDate);
    const endDate2 = this.formatDate(oneWeekAgo2);
    this.selectedDateRangeLine=[startDate,endDate]
    this.selectedJapaneseZhouYueLivingColum=endDate2;
    this.lineChart = echarts.init(this.$refs.lineChart);
    this.selectedDateRangeLineAndColumn=[startDate,endDate]
    this.selectedDaoPeopleColumn=[startDate,endDate]
    this.lineChartAndColumn = echarts.init(this.$refs.lineChartAndColumn);
    this.selectedDateRangeLineEvery=endDate
    this.lineChartEvery = echarts.init(this.$refs.lineChartEvery);
    this.ColomChartRedEnvelope=echarts.init(this.$refs.ColumChartRedEnvelope);
    this.RetentionRateChat=echarts.init(this.$refs.RetentionRateChat);
    this.JapaneseZhouYueLivingRoate=echarts.init(this.$refs.JapaneseZhouYueLivingRoate)
    this.getLineArray()
    this.getLineAndColumArray()
    this.getLineAndEvery()
    this.getPeopleNumber()
    this.getRetentionRate()
    this.getLineAndZhouYueRi()
  },

  methods: {
    async getInfo() {
      // 最下面的柱状图
      try {
        const res1 = await this.$get('v1/admin/community-user', {});
        if (res1.data.status === 'success') {
          this.downExcel = res1.data.downExcel;
          this.districts = res1.data.districts;
          // console.log(this.districts)
          this.selectedArea = [
            this.districts[0].label,
            this.districts[0].children[0].label,
            this.districts[0].children[0].children[0].label
          ];
        } else {
          this.$msg(res1.data.msg);
        }
      } catch (error) {
        console.error('获取数据失败：', error);
      }
      //
      // 年龄分布
      try {
        const res2 = await this.$get('/v1/admin/users-age-distribution', {});
        if (res2.data.status === 'success') {
          const resData = this.classifyAgeData(res2.data.data.age_distribution)
          for (const key in resData) {
            this.pieDataList[0].data.push({name: `${key}`, value: resData[key]});
          }

        } else {
          this.$msg(res2.data.msg);
        }
      } catch (error) {
        console.error('获取数据失败：', error);
      }
      //留存率

      //日活月活人数
      // try {
      //   const res2 = await this.$get('/v1/admin/users-1-7-30-login_counts', {});
      //   if (res2.data.status === 'success') {
      //     // const resData = this.classifyAgeData(res2.data.data.age_distribution)
      //     console.log(res2.data)
      //     const data=res2.data;
      //     for (const key in data) {
      //       if(key=='last_30_days_login_counts'){
      //         this.pieDataList[2].data.push({name: '月活用户数', value: data[key]});
      //       }
      //       if(key=='last_week_login_counts'){
      //         this.pieDataList[2].data.push({name: '周活用户数', value: data[key]});
      //       }
      //       if(key=='today_login_counts'){
      //         this.pieDataList[2].data.push({name: '日活用户数', value: data[key]});
      //       }
      //     }
      //   } else {
      //     this.$msg(res2.data.msg);
      //   }
      // } catch (error) {
      //   console.error('获取数据失败：', error);
      // }
      // 地图的获取
      try {
        const res2 = await this.$get('/v1/admin/users-area-distribution', {});
        if (res2.data.status === 'success') {
          this.provinceData = res2.data.data.provinceData

        } else {
          this.$msg(res2.data.msg);
        }
      } catch (error) {
        console.error('获取数据失败：', error);
      }
      //用户设备分布
      try {
        const res2 = await this.$get('/v1/admin/users-login-device-stats', {});
        if (res2.data.status === 'success') {

          const data=this.categorizeDevices(res2.data.data)

          for (const key in data) {
            this.pieDataList[1].data.push({name: `${key}`, value: data[key]});

          }


        } else {
          this.$msg(res2.data.msg);
        }
      } catch (error) {
        console.error('获取数据失败：', error);
      }
      //用户红包统计
      try {
        const res2 = await this.$get('/v1/admin/users-balance-stats', {});
        if (res2.data.status === 'success') {
          const data=res2.data.balance_count
          for (const key in data) {
            this.ColomChartRedEnvelopeArr.push({name: `${key}`, value: data[key]});
          }

        } else {
          this.$msg(res2.data.msg);
        }
      } catch (error) {
        console.error('获取数据失败：', error);
      }
      //用户留存率统计

  //画下面的饼状图和柱状图
      this.renderCharts();
      this.initColumChart();
      this.initChart();
    },
    //对年龄进行析出
    classifyAgeData(data) {
      const result = {
        '小于60': 0,
        '60-70': 0,
        '70-80': 0,
        '80-90': 0,
        '大于90': 0
      };

      for (const age in data) {
        const value = data[age];
        const parsedAge = parseInt(age);
        if (parsedAge < 60) {
          result['小于60'] += value;
        } else if (parsedAge >= 60 && parsedAge < 70) {
          result['60-70'] += value;
        } else if (parsedAge >= 70 && parsedAge < 80) {
          result['70-80'] += value;
        } else if (parsedAge >= 80 && parsedAge < 90) {
          result['80-90'] += value;
        } else {
          result['大于90'] += value;
        }
      }
    console.log(result)
      return result;
    },
    categorizeDevices(data) {
      const categorizedData = {
        '苹果': [],
        '安卓': [],
        '电脑': [],
      };

      const keywords = {
        '苹果': ['iPhone'],
        '安卓': ['vivo', 'Meizu', 'HUAWEI', 'Xiaomi', 'Redmi', 'OPPO', 'Samsung'],
        '电脑': ['microsoft'],
      };

      for (const [deviceName, count] of Object.entries(data)) {
        let categorized = false;

        for (const [category, categoryKeywords] of Object.entries(keywords)) {
          if (categoryKeywords.some(keyword => deviceName.includes(keyword))) {
            categorizedData[category].push({ deviceName, count });
            categorized = true;
            break;
          }
        }

        if (!categorized) {
          categorizedData['安卓'].push({ deviceName, count });
        }
      }

      // Calculate total count for each category
      for (const [category, devices] of Object.entries(categorizedData)) {
        const totalCount = devices.reduce((total, device) => total + device.count, 0);
        categorizedData[category] = totalCount;
      }

      return categorizedData;
    },

    //画饼状图的函数
    renderCharts() {
      this.pieDataList.forEach((pieData, index) => {
        const chart = echarts.init(this.$refs['chart' + index][0]);
        const option = {
          title: {
            text: '',
            left: 'center',
            top: 'top'
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          series: [
            {
              center: ['50%', '65%'],
              name: '数据',
              type: 'pie',
              radius: '65%',
              data: pieData.data
            }
          ]
        };
        chart.setOption(option);
      });

      const barChart = echarts.init(this.$refs['barChart']);
      this.updateBarChart(barChart);
    },
    initColumChart(){
      const xAxisData = this.ColomChartRedEnvelopeArr.map(item => item.name);
      const yAxisData = this.ColomChartRedEnvelopeArr.map(item => item.value);
      const barOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          right: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: xAxisData,
          axisLabel: {
            show: true, // 是否显示刻度标签，默认显示
            interval: 0, // 坐标轴刻度标签的显示间隔，在类目轴中有效；默认会采用标签不重叠的策略间隔显示标签；可以设置成0强制显示所有标签；如果设置为1，表示『隔一个标签显示一个标签』，如果值为2，表示隔两个标签显示一个标签，以此类推。
            rotate: -20, // 刻度标签旋转的角度，在类目轴的类目标签显示不下的时候可以通过旋转防止标签之间重叠；旋转的角度从-90度到90度
            inside: false, // 刻度标签是否朝内，默认朝外
            margin: 6, // 刻度标签与轴线之间的距离
            formatter: '{value}', // 刻度标签的内容格式器
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value} 人'
          }
        },
        series: [
          {
            data: yAxisData,
            type: 'bar',
            barWidth: '40%',
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示数值
                  position: 'top', //数值在上方显示
                  textStyle: {  //数值样式
                    color: 'black',   //字体颜色
                    fontSize: 14  //字体大小
                  }
                }
              }
            }
          }
        ]
      };

      // const barChart1 = echarts.init(this.$refs.barChart);
      this.ColomChartRedEnvelope.setOption(barOption);
      this.ColomChartRedEnvelope.resize();
    },
    //画最下面的省份选择的柱状图
    updateBarChart() {
      const selectedProvince = this.selectedArea[0];
      const selectedCity = this.selectedArea[1];
      const selectedDistrict = this.selectedArea[2];

      const areas = this.districts.find(province =>
        province.label === selectedProvince
      ).children.find(city =>
        city.label === selectedCity
      ).children.find(district =>
        district.label === selectedDistrict
      ).areas;
      this.messageProviced=0
      const xAxisData = areas.map(item => item.name);
      const yAxisData = areas.map(item => item.value);
      areas.map(item => {
      this.messageProviced+=item.value
      });
      const barOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '6%',
          top: '28%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: xAxisData,
          axisLabel: {
            show: true, // 是否显示刻度标签，默认显示
            interval: 0, // 坐标轴刻度标签的显示间隔，在类目轴中有效；默认会采用标签不重叠的策略间隔显示标签；可以设置成0强制显示所有标签；如果设置为1，表示『隔一个标签显示一个标签』，如果值为2，表示隔两个标签显示一个标签，以此类推。
            rotate: -20, // 刻度标签旋转的角度，在类目轴的类目标签显示不下的时候可以通过旋转防止标签之间重叠；旋转的角度从-90度到90度
            inside: false, // 刻度标签是否朝内，默认朝外
            margin: 6, // 刻度标签与轴线之间的距离
            formatter: '{value}', // 刻度标签的内容格式器
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value} 人'
          }
        },
        series: [
          {
            data: yAxisData,
            type: 'bar',
            barWidth: '40%',
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示数值
                  position: 'top', //数值在上方显示
                  textStyle: {  //数值样式
                    color: 'black',   //字体颜色
                    fontSize: 14  //字体大小
                  }
                }
              }
            }
          }
        ]
      };

      const barChart1 = echarts.init(this.$refs.barChart);
      barChart1.setOption(barOption);
      barChart1.resize();
    },
//文件导出函数
     exportData() {


        // 最下面的柱状图

      const link = document.createElement('a');
      link.href = this.downExcel;
      link.target = '_blank';
      link.download = this.downExcel;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // 导出记录
     exportDaoData() {
      console.log('导出记录1',this.selectedDaoPeopleColumn)
      console.log('导出记录2',this.selectedDaoPeopleColumn[0])
      console.log('导出记录3',this.selectedDaoPeopleColumn[1])


          // 处理返回的数据
          // console.log(response)
          const downExcel = 'https://kxht.naolingtong.com/v1/admin/community-users-by-date?begin_date=' + this.selectedDaoPeopleColumn[0] + '&end_date='+ this.selectedDaoPeopleColumn[1];
          console.log(downExcel,'downExcel')
          const link = document.createElement('a');
          link.href = downExcel;
          link.target = '_blank';
          link.download = downExcel;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);



      // console.log(res1.data)



    },
//活跃人数等的折线图
    async getLineArray(){
      this.lineChart.showLoading({
        text : '暂无数据',
        effectOption: {backgroundColor: 'transparent'}
      })
        try {
            axios.get('/v1/admin/users-related-by-date?begin_date='+this.selectedDateRangeLine[0]+ '&end_date=' + this.selectedDateRangeLine[1] )
              .then(response => {
              // 处理返回的数据

                if (response.data.status === 'success') {
                  this.dataLine=[]

                  const length=response.data.data.length
                  for(let i =0;i<length;i++){
                    const data=response.data.data[i]
                    this.dataLine.push(data)
                    if(i==length-1){

                      this.initLineChartLine();
                    }
                  }
                } else {
                  this.$msg(response.data.msg);
                }

            })
              .catch(error => {
                // 处理错误
                console.error(error);
              });




        }
        catch (error) {
          console.error('获取数据失败：', error);
        }

    },
    //活跃人数等的折线图
    async getPeopleNumber(){
      try {
        axios.get('/v1/admin/users-related-by-date?begin_date='+this.selectedDateRangeLineEvery+ '&end_date=' + this.selectedDateRangeLineEvery )
          .then(response => {
            // 处理返回的数据

            if (response.data.status === 'success') {

                this.message=response.data.data[0].total_users
              // console.log(data)



            } else {
              this.$msg(response.data.msg);
            }

          })
          .catch(error => {
            // 处理错误
            console.error(error);
          });




      }
      catch (error) {
        console.error('获取数据失败：', error);
      }

    },
    //总点击次数的折线图和时长的柱状图
    async getLineAndColumArray(){
      this.lineChartAndColumn.showLoading({
        text : '暂无数据',
        effectOption: {backgroundColor: 'transparent'}
      })

      try {

        axios.get('/v1/admin/users-login-stats?begin_date='+this.selectedDateRangeLineAndColumn[0]+ '&end_date=' + this.selectedDateRangeLineAndColumn[1] )
          .then(response => {
            // 处理返回的数据

            if (response.data.status === 'success') {


              this.dataLineAndColumn=[]

              const length=response.data.data.length
              for(let i =0;i<length;i++){
                const data=response.data.data[i]
                this.dataLineAndColumn.push(data)
                if(i==length-1){
                  this.initLineChartLineAndColum();
                }
              }
            } else {
              this.$msg(response.data.msg);
            }



          })
          .catch(error => {
            // 处理错误
            console.error(error);
          });




      }
      catch (error) {
        console.error('获取数据失败：', error);
      }

    },
    // 各自模块的点击次数的折线图和柱状图
    async getLineAndEvery(){
      this.lineChartEvery.showLoading({
        text : '暂无数据',
        effectOption: {backgroundColor: 'transparent'}
      })

      try {

        axios.get('/v1/admin/users-page-time-stats?begin_date='+this.selectedDateRangeLineEvery+ '&end_date=' + this.selectedDateRangeLineEvery)
          .then(response => {
            // 处理返回的数据

            if (response.data.status === 'success') {


              this.dataLineEvery=[]

              const length=response.data.data[0].page_stats.length

              for(let i =0;i<length;i++){
                const data=response.data.data[0].page_stats[i]
                this.dataLineEvery.push(data)
                if(i==length-1){

                  this.initLineChartLineEvery();
                }
              }
            } else {
              this.$msg(response.data.msg);
            }



          })
          .catch(error => {
            // 处理错误
            console.error(error);
          });




      }
      catch (error) {
        console.error('获取数据失败：', error);
      }

    },

    //日活月活周活人数
    async getLineAndZhouYueRi(){
      this.JapaneseZhouYueLivingRoate.showLoading({
        text : '暂无数据',
        effectOption: {backgroundColor: 'transparent'}
      })

      try {

        axios.get('/v1/admin/users-1-7-30-login_counts?begin_date='+this.selectedJapaneseZhouYueLivingColum)
          .then(response => {
            // 处理返回的数据
            this.DataZhouYueLivingRoate=[]
            if (response.data.status === 'success') {
              const data=response.data;

              const keys = Object.keys(data);

              for (let i = 0; i < keys.length; i++) {
                const key = keys[i];
                const value = data[key];
                if(key=='today_login_counts'){
                  this.DataZhouYueLivingRoate.push({name: '日活用户数', value: value});
                }
                if(key=='last_week_login_counts'){
                  this.DataZhouYueLivingRoate.push({name: '周活用户数', value: value});
                }
                if(key=='last_30_days_login_counts'){
                  this.DataZhouYueLivingRoate.push({name: '月活用户数', value: value});
                }

                if (i === keys.length - 1) {
                  const sortOrder = ['日活用户数', '周活用户数', '月活用户数'];
                  this.DataZhouYueLivingRoate.sort((a, b) => {
                    const indexA = sortOrder.indexOf(a.name);
                    const indexB = sortOrder.indexOf(b.name);

                    return indexA - indexB;
                  });
                  this.initLineChartLineZhouRiYue();
                  // console.log('This is the last property.');
                }
              }
              // for (const key in data) {
              //
              // }


            } else {
              this.$msg(response.data.msg);
            }

          })





      }
      catch (error) {
        console.error('获取数据失败：', error);
      }

    },
    async getRetentionRate(){
      this.RetentionRateChat.showLoading({
        text : '暂无数据',
        effectOption: {backgroundColor: 'transparent'}
      })

      try {

        axios.get('/v1/admin/users-retention-rate')
          .then(response => {
            // 处理返回的数据

            if (response.data.status === 'success') {


              this.RetentionRateChatArray=[]

              const data=response.data.retention_rates

              for (const key in data) {
                this.RetentionRateChatArray.push({name: `${key}`, value: data[key]});
              }
              this.RetentionRateChatArray.sort((a, b) => {
                const numA = parseInt(a.name); // 解析name中的数字部分
                const numB = parseInt(b.name);

                return numA - numB; // 根据数字大小进行排序
              });

              console.log(this.RetentionRateChatArray)
              this.initUserRateLine();
            } else {
              this.$msg(response.data.msg);
            }



          })
          .catch(error => {
            // 处理错误
            console.error(error);
          });




      }
      catch (error) {
        console.error('获取数据失败：', error);
      }

    },
    //初始化地图
    initChart() {
      echarts.registerMap('china', {geoJSON: chinaMap});
      this.chart = echarts.init(this.$refs.mapChart);
      this.chart.setOption(this.getOption());
      this.chart.on('click', this.handleMapClick); // 点击事件绑定到handleMapClick函数
      const defaultProvince = '北京市';
      this.handleClickOnProvince(defaultProvince);
    },
    //点击地图
    handleClickOnProvince(provinceName) {
      const params = {name: provinceName};
      this.handleMapClick(params);
    },
    //获取地图的数据
    generateProvinceValueData(provinceData, provinceNames) {
      return provinceNames.map((provinceName) => {
        const cities = provinceData[provinceName];
        const totalValue = cities ? cities.reduce((total, city) => total + city.value, 0) : 0;
        return {
          name: provinceName,
          value: totalValue
        };
      });
    },
  //画出来地图的相关函数
    getOption() {
      const provinceNames = [
        '北京市', '天津市', '上海市', '重庆市', '河北省', '山西省', '辽宁省', '吉林省', '黑龙江省', '江苏省',
        '浙江省', '安徽省', '福建省', '江西省', '山东省', '河南省', '湖北省', '湖南省', '广东省', '海南省',
        '四川省', '贵州省', '云南省', '陕西省', '甘肃省', '青海省', '台湾省', '内蒙古自治区', '广西壮族自治区', '西藏自治区',
        '宁夏回族自治区', '新疆维吾尔自治区', '香港特别行政区', '澳门特别行政区'
      ];

      const provinceValueData = this.generateProvinceValueData(this.provinceData, provinceNames);

      const option = {
        tooltip: {
          show: this.showLabel,
          formatter: '{b}<br/>{c}人',

        },
        visualMap: {
          left: 40,
          top: 0,
          min: 0,
          max: 700,
          inRange: {
            color: [
              '#e7e8ea',
              '#b8d6da',  // 渐变颜色，0值对应较浅颜色
              '#6ab1c2',  // 渐变颜色，10值对应较深颜色
              '#3d90c6',
              '#2e6db0',
              '#2a4783',
              '#4e79a7',
              '#f28e2b',
              '#e15759',
              '#76b7b2',
              '#59a14f',
              '#edc948',
              '#b07aa1',
              '#ff9da7',
              '#9c755f',
              '#bab0ac',
              '#e41a1c',
              '#377eb8',
              '#4daf4a',
            ]
          },

          text: ['High', 'Low'],
          calculable: true
        },
        series: [
          {
            type: 'map',
            map: 'china',

            layoutCenter: ['30%', '52%'],
            layoutSize: 800,
            data: provinceValueData,
            label: {
              emphasis: {
                textStyle: {
                  fontSize: 16
                }
              }
            },
          }
        ]
      };
      // 点击地图时取消小标签的显示

      return option;
    },
  //点击地图
    handleMapClick(params) {

      const {name} = params;
      this.currentProvince = '';

      if (this.provinceData[name]) {
        this.showLabel = false
        // 移除地图的 click 事件监听器
        this.currentProvince = name;
        this.showPieChart = true;
        // this.chart.dispose(); // 销毁之前的 ECharts 实例

        this.initPieChart();


      }
    },
    initPieChart() {
      // 检查DOM元素是否存在
      // 使用Vue的$nextTick确保DOM元素正确加载
      this.$nextTick(() => {
        this.pieChart = echarts.init(this.$refs.pieChart);
        this.pieChart.setOption(this.getPieOption());
      });
    },

    // 省份的
    getPieOption() {
      const cities = this.provinceData[this.currentProvince] || [];
      const validCities = cities.filter(city => city.value > 0);

      return {

        legend: {
          top: 'auto',
          left: 'center',
          selectedMode: false, //取消图例上的点击事件

        },
        series: [
          {
            layoutCenter: ['70%', '40%'],
            center: ['50%', '68%'],
            layoutSize: 250,
            type: 'pie',
            radius: ['30%', '60%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },

            emphasis: {
              label: {
                show: true,

                fontSize: 30,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },

            data: validCities.map(city => ({
              name: city.name,
              value: city.value
            })),
            label: {
              show: false,
              formatter: '{b}\n{c}人',
              position: 'center'
            }
          }
        ]
      };
    },

    disabledDate(date) {
      return date < this.minDate || date > this.maxDate;
    },

    formatDate(dateObject) {
      const year = dateObject.getFullYear();
      const month = String(dateObject.getMonth() + 1).padStart(2, '0');
      const day = String(dateObject.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    initLineChartLine() {

      this.updateLineChart();
    },
    initLineChartLineAndColum() {
      this.updateLineChartAndColum();
    },
    initLineChartLineEvery() {
      this.updateLineChartEvery();
    },
    initLineChartLineZhouRiYue() {
      this.updateLineZhouRiYue();
    },
    initUserRateLine() {
      this.upUserRateLine();
    },
    //更新数据用
    updateLineChart() {
      // 更新折线图数据

      const selectedDataLine = this.getSelectedDataLine();


      const optionLine = {
        // dimensions: ["金额", "2020年累计消费", "2021年累计消费"],
        // 配置折线图选项
        xAxis: {
          type: 'category',

          data: selectedDataLine.map(item => item.date),
        },
        legend: {
          data: ['当日活跃用户数', '当日完成推送人数', '当日登录人数', '当日注册人数','当日完成任务的百分比'],
          selected:{
            '当日活跃用户数':true,
            '当日完成推送人数':true,
            '当日登录人数':true,
              '当日注册人数':true,
            '当日完成任务的百分比':true,
                '总人数':false
          }
        }
        ,
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          right: '20%',
          // containLabel: true
        },
        yAxis: [
          {
            position: 'left',
            alignTicks: true,
            type: 'value',
            name: '人数',
            axisLine: {
              show: true,
            },
            axisLabel: {
              formatter: '{value} 人'
            }
          },
          {
            type: 'value',
            name: '百分比',
            position: 'right',
            alignTicks: true,
            axisLine: {
              show: true,
            },
            axisLabel: {
              formatter: '{value} %'
            }
          },
        ],
        series: [
          {
            name: '当日活跃用户数',
            type: 'line',
            emphasis: {
              focus: 'series'
            },
            data: selectedDataLine.map(item => item.active_users_count),
          },
          {
            name: '当日完成推送人数',
            type: 'line',
            emphasis: {
              focus: 'series'
            },
            data: selectedDataLine.map(item => item.completed_task_users_count),
          },
          {
            name: '当日登录人数',
            type: 'line',
            emphasis: {
              focus: 'series'
            },
            data: selectedDataLine.map(item => item.logged_users_count),
          },
          {
            name: '当日注册人数',
            type: 'line',
            emphasis: {
              focus: 'series'
            },
            data: selectedDataLine.map(item => item.reg_users_count),
          },
          {
            name: '当日完成任务的百分比',
            type: 'bar',
            yAxisIndex: 1,
            barWidth: '20%',
            emphasis: {
              focus: 'series'
            },
            data: selectedDataLine.map(item => item.completion_rate_of_daily_tasks),
          },

          // {
          //   name: '总人数',
          //   type: 'line',
          //   data: selectedDataLine.map(item => item.total_users),
          // },

        ],
      };
      this.lineChart.hideLoading();
      this.lineChart.setOption(optionLine);
    },
    upUserRateLine() {
      // 更新折线图数据




      const optionLine = {
        // dimensions: ["金额", "2020年累计消费", "2021年累计消费"],
        // 配置折线图选项
        xAxis: {
          type: 'category',
          data:   this.RetentionRateChatArray.map(item => item.name),
        },
        legend: {
          data: ['用户留存率'],
          selected:{
            '用户留存率':true,

          }
        }
        ,
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          right: '15%',
          // containLabel: true
        },
        yAxis: [
          // {
          //   position: 'left',
          //   alignTicks: true,
          //   type: 'value',
          //   name: '人数',
          //   axisLine: {
          //     show: true,
          //   },
          //   axisLabel: {
          //     formatter: '{value} 人'
          //   }
          // },
          {
            type: 'value',
            name: '百分比',
            position: 'left',
            alignTicks: true,
            axisLine: {
              show: true,
            },
            axisLabel: {
              formatter: '{value} %'
            }
          },
        ],
        series: [
          {
            name: '用户留存率',
            type: 'bar',
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示数值
                  position: 'top', //数值在上方显示
                  textStyle: {  //数值样式
                    color: 'black',   //字体颜色
                    fontSize: 14  //字体大小
                  }
                }
              }
            },
            barWidth: '30%',
            data: this.RetentionRateChatArray.map(item => item.value),
          },

        ],
      };
     this.RetentionRateChat.hideLoading();
      this.RetentionRateChat.setOption(optionLine);
    },
    updateLineChartAndColum() {
      // 更新折线图数据

      const selectedDataLine = this.getSelectedDataLineAndColum();
      const optionLine = {

        grid: {
          right: '20%'
        },
        tooltip: {
          trigger: 'axis', // 设置为 'axis'，即在坐标轴上显示 tooltip

          formatter: function(params) {
            const formatItem = (name, value, color) => {
              return `<div>
                <span style="display: inline-block; width: 10px; height: 10px; background-color: ${color}; border-radius: 50%; margin-right: 5px;"></span>
                ${name}：${value}
              </div>`;
            };

            let content = `<div style=" font-size: 12px">${params[0].name}</div>`;
            content += formatItem(params[0].seriesName, params[0].value, params[0].color);
            content += formatItem(params[1].seriesName, params[1].value, params[1].color);
            content += formatItem(params[2].seriesName, params[2].value, params[2].color);
            return content;
          },

        },

        // dimensions: ["金额", "2020年累计消费", "2021年累计消费"],
        // 配置折线图选项

        xAxis: {
          type: 'category',

          data: selectedDataLine.map(item => item.date),
          axisPointer: {
            type: 'shadow'
          }
        },

        legend: {
          data: ['登录总次数', '平均使用时间', '总使用时间',],

        },

        yAxis: [

          {
            type: 'value',
            name: '使用时长',
            position: 'right',
            alignTicks: true,
            axisLine: {
              show: true,
            },
            axisLabel: {
              formatter: value => this.formatDuration(value),
            },
          },

          {
            position: 'left',
            alignTicks: true,
            type: 'value',
            name: '总登录次数',
            axisLine: {
              show: true,
            },
            axisLabel: {
              formatter: '{value} 次'
            }

          },
        ],
        series: [
          {
            name: '登录总次数',
            type: 'line',
            yAxisIndex: 1,
            emphasis: {
              focus: 'series'
            },
            data: selectedDataLine.map(item => item.total_logins),
          },
          {
            name: '平均使用时间',
            type: 'bar',
            data: selectedDataLine.map((value, index, array)  => {
            return this.formatDuration( value.avg_duration_s)
            }),
            barWidth: '0%'
          },
          {

            name: '总使用时间',
            type: 'bar',
            data: selectedDataLine.map((value, index, array) => {
              return this.formatDuration(value.total_duration_s);
            }),
            barWidth: '0%'
          },
          {
            name: '平均使用时间',
            type: 'bar',
            yAxisIndex: 0,
            data: selectedDataLine.map((value, index, array)  => {
              return  value.avg_duration_s
            }),
            label: {
              show: false, // 这里设置为 false，悬停时不显示数据
            },
            emphasis: {
              focus: 'series'
            },
            barWidth: '20%'
          },
          {
            name: '总使用时间',
            type: 'bar',
            yAxisIndex: 0,
            label: {
              show: false, // 这里设置为 false，悬停时不显示数据
            },
            emphasis: {
              focus: 'series'
            },
            data: selectedDataLine.map((value, index, array) => {
              return value.total_duration_s
            }),
            barWidth: '20%'
          },

        ],
      };
      this.lineChartAndColumn.hideLoading();
      this.lineChartAndColumn.setOption(optionLine);
    },
    updateLineChartEvery() {
      // 更新折线图数据

      const selectedDataLine = this.dataLineEvery
      const optionLine = {

        grid: {
          right: '20%'
        },
        tooltip: {
          trigger: 'axis', // 设置为 'axis'，即在坐标轴上显示 tooltip

          formatter: function(params) {
            const formatItem = (name, value, color) => {
              return `<div>
                <span style="display: inline-block; width: 10px; height: 10px; background-color: ${color}; border-radius: 50%; margin-right: 5px;"></span>
                ${name}：${value}
              </div>`;
            };

            let content = `<div style=" font-size: 12px">${params[0].name}</div>`;
            content += formatItem(params[0].seriesName, params[0].value, params[0].color);
            content += formatItem(params[1].seriesName, params[1].value, params[1].color);
            content += formatItem(params[2].seriesName, params[2].value, params[2].color);
            return content;
          },

        },

        // dimensions: ["金额", "2020年累计消费", "2021年累计消费"],
        // 配置折线图选项

        xAxis: {
          type: 'category',

          data: selectedDataLine.map(item => item.page_content),
          axisPointer: {
            type: 'shadow'
          },
          axisLabel: {
            show: true, // 是否显示刻度标签，默认显示
            interval: 0, // 坐标轴刻度标签的显示间隔，在类目轴中有效；默认会采用标签不重叠的策略间隔显示标签；可以设置成0强制显示所有标签；如果设置为1，表示『隔一个标签显示一个标签』，如果值为2，表示隔两个标签显示一个标签，以此类推。
            rotate: -20, // 刻度标签旋转的角度，在类目轴的类目标签显示不下的时候可以通过旋转防止标签之间重叠；旋转的角度从-90度到90度
            inside: false, // 刻度标签是否朝内，默认朝外
            margin: 6, // 刻度标签与轴线之间的距离
            formatter: '{value}', // 刻度标签的内容格式器
          },
        },

        legend: {
          data: ['点击次数', '平均使用时间', '总使用时间',],

        },

        yAxis: [

          {
            type: 'value',
            name: '平均使用时长',
            position: 'right',
            alignTicks: true,
            axisLine: {
              show: true,

            },
            axisLabel: {
              formatter: value => this.formatDuration(value),
            },
          },

          {
            position: 'left',
            alignTicks: true,
            type: 'value',
            name: '点击次数',
            axisLine: {
              show: true,

            },
            axisLabel: {
              formatter: '{value} 次'
            }
          },
        ],
        series: [
          {
            name: '点击次数',
            type: 'line',
            yAxisIndex: 1,
            emphasis: {
              focus: 'series'
            },
            data: selectedDataLine.map(item => item.total_count),
          },
          {
            name: '平均使用时间',
            type: 'bar',
            data: selectedDataLine.map((value, index, array)  => {
              return this.formatDuration( value.avg_duration_s)
            }),
            barWidth: '0%'
          },
          {

            name: '总使用时间',
            type: 'bar',
            data: selectedDataLine.map((value, index, array) => {
              return this.formatDuration(value.total_duration_s);
            }),
            barWidth: '0%'
          },
          {
            name: '平均使用时间',
            type: 'bar',
            yAxisIndex: 0,
            data: selectedDataLine.map((value, index, array)  => {
              return  value.avg_duration_s
            }),
            emphasis: {
              focus: 'series'
            },
            label: {
              show: false, // 这里设置为 false，悬停时不显示数据
            },

          },

          {
            name: '总使用时间',
            type: 'bar',
            yAxisIndex: 0,
            emphasis: {
              focus: 'series'
            },
            label: {
              show: false, // 这里设置为 false，悬停时不显示数据
            },
            data: selectedDataLine.map((value, index, array) => {
              return value.total_duration_s
            }),

          },

        ],
      };
      this.lineChartEvery.hideLoading();
      this.lineChartEvery.setOption(optionLine);
    },
    updateLineZhouRiYue() {
      // 更新折线图数据

      const selectedDataLine = this.DataZhouYueLivingRoate
      const optionLine = {

        grid: {
          right: '20%',
          axisPointer: {
            type: 'shadow'
          }
        },


        // dimensions: ["金额", "2020年累计消费", "2021年累计消费"],
        // 配置折线图选项

        xAxis: {
          type: 'category',
          data: selectedDataLine.map(item => item.name),
          axisPointer: {
            type: 'shadow'
          },
          axisLabel: {
            show: true, // 是否显示刻度标签，默认显示
            interval: 0, // 坐标轴刻度标签的显示间隔，在类目轴中有效；默认会采用标签不重叠的策略间隔显示标签；可以设置成0强制显示所有标签；如果设置为1，表示『隔一个标签显示一个标签』，如果值为2，表示隔两个标签显示一个标签，以此类推。
            rotate: -20, // 刻度标签旋转的角度，在类目轴的类目标签显示不下的时候可以通过旋转防止标签之间重叠；旋转的角度从-90度到90度
            inside: false, // 刻度标签是否朝内，默认朝外
            margin: 6, // 刻度标签与轴线之间的距离
            formatter: '{value}', // 刻度标签的内容格式器
          },
        },
        yAxis: [
          {
            position: 'left',
            alignTicks: true,
            type: 'value',
            name: '人数',
            axisLine: {
              show: true,
            },
            axisLabel: {
              formatter: '{value} 人'
            }
          },
        ],
        series: [
          {
            type: 'bar',
            barWidth: '30%',
            data: selectedDataLine.map(item => item.value),
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示数值
                  position: 'top', //数值在上方显示
                  textStyle: {  //数值样式
                    color: 'black',   //字体颜色
                    fontSize: 14  //字体大小
                  }
                }
              }
            },
          },
        ],
      };
      this.JapaneseZhouYueLivingRoate.hideLoading();
      this.JapaneseZhouYueLivingRoate.setOption(optionLine);
    },
    //日期返回
    getSelectedDataLine() {
      // 根据选定的时间范围获取子集数据
      return this.dataLine.filter(item => {
        const date = new Date(item.date);
        const startDate = new Date(this.selectedDateRangeLine[0]);
        const endDate = new Date(this.selectedDateRangeLine[1]);
        return date >= startDate && date <= endDate;
      });
    },
    getSelectedDataLineAndColum() {
      // 根据选定的时间范围获取子集数据
      return this.dataLineAndColumn.filter(item => {
        const date = new Date(item.date);
        const startDate = new Date(this.selectedDateRangeLineAndColumn[0]);
        const endDate = new Date(this.selectedDateRangeLineAndColumn[1]);
        return date >= startDate && date <= endDate;
      });
    },
      //日期返回
    formatDuration(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secondsRemain = seconds % 60;
      return `${hours}时${minutes}分${secondsRemain}秒`;
    },
    //近一周一个月的返回数据
    setDateRangeLine(range) {
      // 根据按钮设置时间范围
      const today = new Date();
      const endDate = today.toISOString().substr(0, 10);
      let startDate = '';

      if (range === '近一周') {
        const oneWeekAgo = new Date(today);
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
        startDate = oneWeekAgo.toISOString().substr(0, 10);
      } else if (range === '近一个月') {
        const oneMonthAgo = new Date(today);
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
        startDate = oneMonthAgo.toISOString().substr(0, 10);
      } else if (range === '近三个月') {
        const threeMonthsAgo = new Date(today);
        threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
        startDate = threeMonthsAgo.toISOString().substr(0, 10);
      }

      this.selectedDateRangeLine = [startDate, endDate];
      console.log(this.selectedDateRangeLine,'selectedDateRangeLineselectedDateRangeLine')
      this.getLineArray();
      // this.updateLineChart(); // 更新折线图
    },
    setDateRangeLineAndColum(range) {
      // 根据按钮设置时间范围
      const today = new Date();
      const endDate = today.toISOString().substr(0, 10);
      let startDate = '';

      if (range === '近一周') {
        const oneWeekAgo = new Date(today);
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
        startDate = oneWeekAgo.toISOString().substr(0, 10);
      } else if (range === '近一个月') {
        const oneMonthAgo = new Date(today);
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
        startDate = oneMonthAgo.toISOString().substr(0, 10);
      } else if (range === '近三个月') {
        const threeMonthsAgo = new Date(today);
        threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
        startDate = threeMonthsAgo.toISOString().substr(0, 10);
      }

      this.selectedDateRangeLineAndColumn = [startDate, endDate];
      this.getLineAndColumArray();
      // this.updateLineChart(); // 更新折线图
    },
    setDateDaoPeopleColum(range) {
      // 根据按钮设置时间范围
      const today = new Date();
      const endDate = today.toISOString().substr(0, 10);
      let startDate = '';

      if (range === '近一周') {
        const oneWeekAgo = new Date(today);
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
        startDate = oneWeekAgo.toISOString().substr(0, 10);
      } else if (range === '近一个月') {
        const oneMonthAgo = new Date(today);
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
        startDate = oneMonthAgo.toISOString().substr(0, 10);
      } else if (range === '近三个月') {
        const threeMonthsAgo = new Date(today);
        threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
        startDate = threeMonthsAgo.toISOString().substr(0, 10);
      }
      this.selectedDaoPeopleColumn = [startDate, endDate];
      // this.getLineAndColumArray();
      // this.updateLineChart(); // 更新折线图
    },
    //日期选择器
    handleDateInputLine(value) {
      // console.log(value,'value')
      if (value && value.length === 2) {

        let start = new Date(new Date(value[0]).getTime() + 8 * 60 * 60 * 1000);
        let end = new Date(new Date(value[1]).getTime() + 8 * 60 * 60 * 1000);

        start = start.toISOString().split('T')[0];
        end = end.toISOString().split('T')[0];

        console.log(start,end,'endend');
        // 设置选定的时间范围
        this.selectedDateRangeLine = [start,end];
        // this.updateLineChart(); // 更新折线图
        this.getLineArray();
      }

    },
    handleDateInputLineAndColum(value) {
      if (value && value.length === 2) {

                let start = new Date(new Date(value[0]).getTime() + 8 * 60 * 60 * 1000);
        let end = new Date(new Date(value[1]).getTime() + 8 * 60 * 60 * 1000);

        start = start.toISOString().split('T')[0];
        end = end.toISOString().split('T')[0];

        console.log(start,end,'endend');
        // 设置选定的时间范围
        this.selectedDateRangeLineAndColumn = [start,end];
        // this.updateLineChart(); // 更新折线图
        this.getLineAndColumArray();
      }

    },
    handleDateDaoPeopleColum(value) {
      // console.log(value,'valuevalue')
      if (value && value.length === 2) {

        let start = new Date(new Date(value[0]).getTime() + 8 * 60 * 60 * 1000);
        let end = new Date(new Date(value[1]).getTime() + 8 * 60 * 60 * 1000);

        start = start.toISOString().split('T')[0];
        end = end.toISOString().split('T')[0];

        console.log(start,end,'endend');
        // 设置选定的时间范围
        this.selectedDaoPeopleColumn = [start, end];
        // this.updateLineChart(); // 更新折线图
        // this.getLineAndColumArray();
      }

    },
    handleDateInputLineEvery(value) {
        // 设置选定的时间范围

        this.selectedDateRangeLineEvery = this.formatDate(value);
        // this.updateLineChart(); // 更新折线图
        this.getLineAndEvery();


    },
    handleDateInputData(value) {
      // 设置选定的时间范围

      this.selectedJapaneseZhouYueLivingColum = this.formatDate(value);
      // this.updateLineChart(); // 更新折线图
      this.getLineAndZhouYueRi();


    },

  },

};
</script>

<style scoped>
.bar-container {
  padding: 20px;
}

.chart-container {
  position: relative;
}
.chart-container1{
  position: relative;
  height: 400px;
}
.dataSelet{
  position: absolute;
  left: 0;
  top: 20px;
}
.chart {
  height: 450px;
}
.ExportRecord{
  position: absolute;
  top: -10px;
  left: 90%;
  display: flex;
  line-height: 15px;
  align-items: center;

}
.chart222 {
  height: 600px;
}

.loadingChart{

  height: 450px;
  width:100%;
  position:absolute;

}
.dropdown-container {
  display: flex;
  align-items: center;
}

/* .dropdown {
  margin-right: 10px;
} */
.pie-container {
  padding: 20px;
}

.pie-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.button-Dao{
  margin-left: 20px;
}
.pie-col {
  flex: 0 0 calc(50% - 20px);
  margin-bottom: 20px;
}

.el-card {
  border: none;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.chart-container {
  position: relative;
}

.chart {
  height: 300px;
}

.chart-title1 {
  padding: 10px;
  background-color: #f2f2f2;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
}
.chart-titleTotol {
  padding: 10px;
  background-color: #f2f2f2;
  width: 100%;
  margin: 0 auto;
  /*text-align: center;*/
  font-size: 14px;
  font-weight: bold;
  text-align: center;
}
.chart-title {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.bar-container {
  margin-top: 20px;
}

.selection-container {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.el-radio-group {
  margin-right: 20px;
}
.map-container {
  margin-top: 50px;
  position: relative;
  width: 100%;
  height: 950px; /* 设置地图容器的高度 */
}

/* 地图图表样式 */
.map-chart,
.chartMap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;


}
.chartMap{
  z-index: 2;
  top: 25%;
  left: 60%;
  width: 35%;
  height: 35%;
}
.PeopleCssProve{
  position: absolute;
  margin-top: 20px;
  margin-left: 20px;
}
.line-chart-container {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.control-panel {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.range-buttons {
  margin-left: 20px;
}

.line-chart {

  width: 100%;
  height: 430px;
}

</style>



// WEBPACK FOOTER //
// src/pages/UserDataAnalyze/UserDataEachars.vue